import { TreasureChestIcon } from './TreasureChestIcon';

/**
 * author: Alex Efremo
 * id A0678E6D-C3D3-42AB-B9E7-C1B12D368B70
 * name treasure-chest
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/treasure-chest.svg
 * tags
 * - Gaming / RPG 
 * - Shopping 
 * - Lock 
 */
export const JewelCaseIcon = TreasureChestIcon;
export default JewelCaseIcon